import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Customer, Product } from '../model';
import { CustomerService } from '../service/customer.service';

@Component({
  selector: 'app-unstyled-components',
  templateUrl: './unstyled-components.component.html',
  styleUrls: ['./unstyled-components.component.scss'],
})
export class UnstyledComponentsComponent implements OnInit {
  floatValue?: string;
  display: boolean = false;
  sliderValue?: number;
  ratingValue?: number;
  switchValue?: boolean;
  selectedProduct?: Product;
  products: Product[] = [];
  tieredMenuItems: MenuItem[] = [];
  menuItems: MenuItem[] = [];
  contextMenuItems: MenuItem[] = [];
  customers: Customer[] = [];
  selectedCustomers: Customer[] = [];

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private customerService: CustomerService
  ) {}

  ngOnInit(): void {
    this.customerService.getCustomersLarge().then((customers) => (this.customers = customers));

    this.tieredMenuItems = [
      {
        label: 'Customers',
        icon: 'pi pi-fw pi-table',
        items: [
          {
            label: 'New',
            icon: 'pi pi-fw pi-user-plus',
            items: [
              {
                label: 'Customer',
                icon: 'pi pi-fw pi-plus',
              },
              {
                label: 'Duplicate',
                icon: 'pi pi-fw pi-copy',
              },
            ],
          },
          {
            label: 'Edit',
            icon: 'pi pi-fw pi-user-edit',
          },
        ],
      },
      {
        label: 'Orders',
        icon: 'pi pi-fw pi-shopping-cart',
        items: [
          {
            label: 'View',
            icon: 'pi pi-fw pi-list',
          },
          {
            label: 'Search',
            icon: 'pi pi-fw pi-search',
          },
        ],
      },
      {
        label: 'Shipments',
        icon: 'pi pi-fw pi-envelope',
        items: [
          {
            label: 'Tracker',
            icon: 'pi pi-fw pi-compass',
          },
          {
            label: 'Map',
            icon: 'pi pi-fw pi-map-marker',
          },
          {
            label: 'Manage',
            icon: 'pi pi-fw pi-pencil',
          },
        ],
      },
      {
        label: 'Profile',
        icon: 'pi pi-fw pi-user',
        items: [
          {
            label: 'Settings',
            icon: 'pi pi-fw pi-cog',
          },
          {
            label: 'Billing',
            icon: 'pi pi-fw pi-file',
          },
        ],
      },
      {
        separator: true,
      },
      {
        label: 'Quit',
        icon: 'pi pi-fw pi-sign-out',
      },
    ];

    this.menuItems = [
      {
        label: 'Customers',
        items: [
          {
            label: 'New',
            icon: 'pi pi-fw pi-plus',
          },
          {
            label: 'Edit',
            icon: 'pi pi-fw pi-user-edit',
          },
        ],
      },
      {
        label: 'Orders',
        items: [
          {
            label: 'View',
            icon: 'pi pi-fw pi-list',
          },
          {
            label: 'Search',
            icon: 'pi pi-fw pi-search',
          },
        ],
      },
    ];

    this.contextMenuItems = [
      {
        label: 'Save',
        icon: 'pi pi-save',
      },
      {
        label: 'Update',
        icon: 'pi pi-refresh',
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
      },
      {
        separator: true,
      },
      {
        label: 'Options',
        icon: 'pi pi-cog',
      },
    ];
  }

  onRowSelect(event: { data: any }, op: any) {
    this.messageService.add({ severity: 'info', summary: 'Product Selected', detail: event.data.name });
    op.hide();
  }

  showConfirmPopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target || undefined,
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });
      },
      reject: () => {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
      },
      key: 'popup',
    });
  }

  showConfirmDialog() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' });
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Rejected', detail: 'You have rejected' });
      },
      key: 'dialog',
    });
  }

  filterTable(dt: any, event: Event) {
    dt.filterGlobal((<HTMLInputElement>event.target).value, 'contains');
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
